module.exports = __webpack_public_path__ + "static/assets/5741924f2937233d3f0c8ef61b5905bc.png";